module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/main-view_685a7ec05f8c4f98a026118cd538c0e8.png";